import React, { Component } from 'react';
import LongText from '../Utils/LongText.js';
import ModalImage from '../Utils/ModalImage.js';

class BulletPoints extends Component {
    render() {
        const { activeButton } = this.props;

        let date = new Date();
        let full_date = date.toLocaleDateString().replace(/\//g, "_");
        let new_workshop_file_name = "AwakeningIntuitionActivityRyanHenaoInstructorsCopy_" + full_date + ".pdf"

        let file_path = "/documents/";
        let workshop_file = "AwakeningIntuitionActivityRyanHenaoInstructorsCopy.pdf";
        let workshop_file_path = file_path + workshop_file;

        let workshop_file_image = "AwakeningIntuitionActivityRyanHenaoInstructorsCopyThumbnail.jpg";
        let workshop_download_image = file_path + workshop_file_image;

        let image_path = "/images/art/workshops/";
        let workshop_image = "workshop_main_image.jpg";
        let workshop_image_path = image_path + workshop_image;

        let workshop_title = <h2>Awakening Intuition Through Artistic Collage</h2>

        let workshop_description = <p>The participants spent time looking through
            magazines, used art books, and other picture books I gathered, cutting out
            images that resonated with them in some way. They were instructed to
            maintain a mindful and inquisitive nature throughout the process as they
            observed which images they chose. Some things to consider were, how each
            image made them feel, what associations arose, and which senses they
            observed them through. After collaging participants were invited to see what
            meaning their art work revealed to them. Similar to Jung's sand-play, the
            imaginative process of collaging various images together on paper helps to
            bring to the surface unconscious feelings, beliefs, goals and motivations;
            the context of a playful, allows for all of this to be done in a safe and
            fun manner.</p>

        return (
            <div className="unset-all">
                {activeButton === 'bulletPoints' && (
                    <div className="bullet-points">
                        <h2>As part of my studies</h2>
                        <ul>
                            <li>Therapeutic workshop exploring creativity</li>
                            <li>Cultivating creative and intuitive thinking</li>
                            <li>Guided self-exploration through engaging activities</li>
                            <li>Visual expression using artistic collaging</li>
                            <li>Showcasing participants' meaningful artwork</li>
                            <li>Surprising personal discoveries in art</li>
                            <li>Non-judgmental curiosity and reflection</li>
                        </ul>
                    </div>
                )}
            </div>
        );
    }
}

export default BulletPoints;